import { validateUrls } from "api/types"
import { getServiceURL } from "api/utils"
import { ServicePrefix } from "utils/constants"

const getHadesURL = getServiceURL(ServicePrefix.hades)

export const urls = validateUrls({
  documents: {
    list: () => getHadesURL(`/v1/documents/`),
    detail: documentId => getHadesURL(`/v1/documents/${documentId}/`),
    tags: () => getHadesURL(`/v1/documents/tags/`),
  },
})
